<template>
    <v-alert
        prominent
        width="50%"
        transition="scale-transition"
        :type="alertType"
    >
        <v-row align="center">
            <v-col class="grow">
                {{ alertMessage }}
            </v-col>
            <v-col class="shrink">
                <v-btn class="primary" @click="reloadPage">
                    OK!
                </v-btn>
            </v-col>
        </v-row>
    </v-alert>
</template>

<script>
export default {
    name: "ErpDialog",
    props: {
        alertType: String,
        alertMessage: String,
    },
    methods: {
        reloadPage(){
            window.location.reload();
        }
    }
}
</script>

<style scoped>

</style>
